module.exports = __webpack_public_path__ + "static/media/cinecruise-logo.b1bc5566.jpg";